<template>
  <div v-if="isDev" @click="toggleAds" class="fixed cursor-pointer left-0 bottom-0 p-2 bg-white/50">Toggle ads</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const toggleAds = () => store.commit('toggleAds');
const isDev = computed(() => ['localhost:3000', 'localwww.nslookup.io', 'stgwww.nslookup.io'].includes(window.location.host));
</script>
